<template>
    <ul class="nav_breadcrumbs">
        <li>
            <router-link to="/modules/home">{{lang.LBL_HOME}}</router-link>
        </li>
        <!-- <li>
            <router-link to="/modules/exinterests/edit">{{lang.LBL_CREATE_EOI}}</router-link>
        </li> -->
        <li>
            <router-link to="/modules/exinterests">{{lang.LBL_VIEW_EOI}}</router-link>
        </li>
    </ul>
</template>
<script>
    import lang from "@/views/modules/ExpressionInterests/language/en";
    export default {
        name: "breadcrumbs",
        data() {
            return {
                lang: [],
            }
        },
        mounted() {
            this.lang = lang;
        },

    }
</script>